// auth.guard.ts
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = () => {
    const router = inject(Router);

    const storedUser = sessionStorage.getItem('auth'); // chave que você usar
    if (storedUser) {
        return true; // segue para a rota
    }

    // se não tiver usuário, redireciona
    router.navigate(['/entrar']);
    return false;
};